.root {
  border-radius: var(--mantine-radius-default) !important;
  padding: 0.5rem 0.75rem !important;

  &[data-size='xl'] {
    padding: 0.625rem 0.875rem !important;
    height: 2.5rem;

    .label {
      font-size: 1rem;
    }
  }

  .label {
    text-transform: none;
    font-weight: 600;
  }

  &[data-variant='light'] {
    &.white-done {
      background: var(--mantine-color-badgeWhite-0);

      .label {
        color: var(--mantine-color-primary-7);
      }
    }

    &.white {
      background: var(--mantine-color-badgeWhite-0);

      .label {
        color: var(--mantine-color-otherWhite-0);
      }
    }

    &.gray {
      background: var(--mantine-color-primary-9);

      .label {
        color: var(--mantine-color-primary-7);
      }
    }

    &.dark {
      background: var(--mantine-color-badgeDark-0);

      .label {
        color: var(--mantine-color-otherWhite-0);
      }
    }

    &.secondary {
      background: var(--mantine-color-secondary-2);

      .label {
        color: var(--mantine-color-secondary-7);
      }
    }

    &.tertiary {
      background: var(--mantine-color-badgeTertiary-0);

      .label {
        color: var(--mantine-color-tertiary-7);
      }
    }

    &.green {
      background: var(--mantine-color-green-2);

      .label {
        color: var(--mantine-color-green-7);
      }
    }

    &.red {
      background: var(--mantine-color-red-2);

      .label {
        color: var(--mantine-color-tertiary-7);
      }
    }

    &.blue {
      background: var(--mantine-color-blue-2);

      .label {
        color: var(--mantine-color-secondary-7);
      }
    }
  }

  &[data-variant='filled'] {
    &.white-done {
      background: var(--mantine-color-primary-7);

      .label {
        color: var(--mantine-color-otherWhite-0);
      }
    }

    &.white {
      background: var(--mantine-color-otherWhite-0);

      .label {
        color: var(--mantine-color-primary-0);
      }
    }

    &.gray {
      background: var(--mantine-color-primary-0);

      .label {
        color: var(--mantine-color-otherBlack-0);
      }
    }

    &.dark {
      background: var(--mantine-color-primary-9);

      .label {
        color: var(--mantine-color-otherBlack-0);
      }
    }

    &.secondary {
      background: var(--mantine-color-secondary-7);

      .label {
        color: var(--mantine-color-otherWhite-0);
      }
    }

    &.tertiary {
      background: var(--mantine-color-tertiary-7);

      .label {
        color: var(--mantine-color-otherWhite-0);
      }
    }

    &.green {
      background: var(--mantine-color-green-7);

      .label {
        color: var(--mantine-color-otherWhite-0);
      }
    }

    &.red {
      background: var(--mantine-color-red-7);

      .label {
        color: var(--mantine-color-otherWhite-0);
      }
    }

    &.blue {
      background: var(--mantine-color-blue-7);

      .label {
        color: var(--mantine-color-otherWhite-0);
      }
    }
  }

  &[data-variant='outline-category'] {
    &.white-done {
      background: transparent;
      border-color: var(--mantine-color-primary-0);

      .label {
        color: var(--mantine-color-textInDark-0);
      }
    }

    &.white {
      background: transparent;
      border-color: var(--mantine-color-primary-0);

      .label {
        color: var(--mantine-color-textGray-0);
      }
    }

    &.gray {
      background: transparent;
      border-color: var(--mantine-color-primary-2);

      .label {
        color: var(--mantine-color-textGray-0);
      }
    }

    &.dark {
      background: transparent;
      border-color: var(--mantine-color-primary-0);

      .label {
        color: var(--mantine-color-textInDark-0);
      }
    }

    &.secondary {
      background: transparent;
      border-color: var(--mantine-color-secondary-7);

      .label {
        color: var(--mantine-color-secondary-7);
      }
    }

    &.tertiary {
      background: transparent;
      border-color: var(--mantine-color-tertiary-7);

      .label {
        color: var(--mantine-color-tertiary-7);
      }
    }

    &.green {
      background: transparent;
      border-color: var(--mantine-color-green-7);

      .label {
        color: var(--mantine-color-green-7);
      }
    }

    &.red {
      background: transparent;
      border-color: var(--mantine-color-red-7);

      .label {
        color: var(--mantine-color-red-7);
      }
    }

    &.blue {
      background: transparent;
      border-color: var(--mantine-color-blue-7);

      .label {
        color: var(--mantine-color-blue-7);
      }
    }
  }

  &[data-variant='light-skill'] {
    &.white-done {
      background: var(--mantine-color-badgeLightSkill-0);

      .label {
        color: var(--mantine-color-secondary-7);
      }
    }

    &.white {
      background: var(--mantine-color-badgeLightSkill-0);

      .label {
        color: var(--mantine-color-primary-0);
      }
    }

    &.gray {
      background: var(--mantine-color-badgeGray-0);

      .label {
        color: var(--mantine-color-textInDark-0);
      }
    }

    &.dark {
      background: var(--mantine-color-badgeDarkSkill-0);

      .label {
        color: var(--mantine-color-textInDark-0);
      }
    }

    &.secondary {
      background: var(--mantine-color-badgeSecondary-0);

      .label {
        color: var(--mantine-color-secondary-7);
      }
    }

    &.tertiary {
      background: var(--mantine-color-badgeTertiaryLightSkill-0);

      .label {
        color: var(--mantine-color-tertiary-7);
      }
    }

    &.green {
      background: var(--mantine-color-badgeGreen-0);

      .label {
        color: var(--mantine-color-green-7);
      }
    }

    &.red {
      background: var(--mantine-color-badgeRed-0);

      .label {
        color: var(--mantine-color-red-7);
      }
    }

    &.blue {
      background: var(--mantine-color-badgeBlue-0);

      .label {
        color: var(--mantine-color-textInDark-0);
      }
    }
  }

  &[data-variant='dot'] {
    &.white-done {
      background: var(--mantine-color-primary-2);

      &::before {
        background: var(--mantine-color-secondary-7);
      }

      .label {
        color: var(--mantine-color-textInDark-0);
      }
    }

    &.white {
      background: var(--mantine-color-primary-9);

      &::before {
        background: var(--mantine-color-primary-0);
      }

      .label {
        color: var(--mantine-color-textInDark-0);
      }
    }

    &.gray {
      background: var(--mantine-color-primary-2);

      &::before {
        background: var(--mantine-color-primary-0);
      }

      .label {
        color: var(--mantine-color-textInDark-0);
      }
    }

    &.dark {
      background: var(--mantine-color-primary-2);

      &::before {
        background: var(--mantine-color-primary-9);
      }

      .label {
        color: var(--mantine-color-textInDark-0);
      }
    }

    &.secondary {
      background: var(--mantine-color-primary-2);

      &::before {
        background: var(--mantine-color-secondary-7);
      }

      .label {
        color: var(--mantine-color-textInDark-0);
      }
    }

    &.tertiary {
      background: var(--mantine-color-primary-2);

      &::before {
        background: var(--mantine-color-tertiary-7);
      }

      .label {
        color: var(--mantine-color-textInDark-0);
      }
    }

    &.green {
      background: var(--mantine-color-primary-2);

      &::before {
        background: var(--mantine-color-green-7);
      }

      .label {
        color: var(--mantine-color-textInDark-0);
      }
    }

    &.red {
      background: var(--mantine-color-primary-2);
      border-color: var(--mantine-color-primary-2);

      &::before {
        background: var(--mantine-color-red-7);
      }

      .label {
        color: var(--mantine-color-textInDark-0);
      }
    }

    &.blue {
      background: var(--mantine-color-primary-2);

      &::before {
        background: var(--mantine-color-blue-7);
      }

      .label {
        color: var(--mantine-color-textInDark-0);
      }
    }
  }

  &[data-size='xs'] {
    .label {
      @extend %text-xs;
    }
  }

  &[data-size='sm'] {
    .label {
      @extend %text-sm;
    }
  }

  &[data-size='md'] {
    .label {
      @extend %text-md;
    }
  }

  &[data-size='lg'] {
    .label {
      @extend %text-lg;
    }
  }

  &[data-size='xl'] {
    .label {
      @extend %text-xl;
    }
  }
}
